<template>
  <div class="page_analysis">
    <div class="topOperation">
      <div class="top-left">
        <div><ShowNavHead /></div>
        <div class="screenInputs">
          <div class="screenInput">
            <el-input
              size="small"
              clearable
              placeholder="请输入总项目名称"
              v-model="listQuery.strallObjName"
              @keyup.enter.native="getList()"
            ></el-input>
            <span style="margin-left: 10px">记账日期:</span>
            <selMonth @func="getBookFormSon"></selMonth>
            <!-- <el-date-picker
              v-model="listQuery.bookingRealMonths"
              type="month"
              :clearable="false"
              value-format="yyyy-MM"
            >
            </el-date-picker> -->
            <span style="margin-left: 10px">归属日期:</span>
            <selMonth @func="getBelongFormSon"></selMonth>
            <!-- <el-date-picker
              v-model="listQuery.belongMonths"
              type="month"
              clearable
              value-format="yyyy-MM"
            >
            </el-date-picker> -->
            <el-button
              type="success"
              plain
              size="small"
              @click="searchEnterFun"
              style="margin-left: 12px"
              >搜索</el-button
            >
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button type="success" size="small" style="margin-right: 10px" plain @click="dropDownScreen">
          筛选
        </el-button>
        <el-button
          type="primary"
          plain
          size="small"
          style="margin-right: 20px;margin-left:0;"
          @click="exportHandle"
          :loading="exportLoading"
          v-show="tableData.length > 0 && !isNull(tableData)"
          >导出</el-button
        >
      </div>
      <!-- 筛选下拉框 -->
      <div class="dropDownScreen" v-show="showDropScreen == 1">
        <div class="inputs">
          <div class="formScreenInput">
            <div>服务中心</div>
            <el-select
              v-model="listQuery.strSrvCent"
              slot="prepend"
              placeholder="请选择"
              filterable
              @change="serviceChange"
            >
              <el-option
                v-for="(item, index) in serviceList"
                :key="index"
                :label="item.StrSrvCent"
                :value="item.StrSrvCent"
              ></el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>项目名称</div>
            <el-input
              size="small"
              clearable
              placeholder="请输入项目名称"
              v-model="listQuery.strObjName"
            ></el-input>
          </div>
        </div>
        <div class="drop-footer">
          <button class="clear" style="margin-right: 10px" @click="resetHandle">
            清空
          </button>
          <button class="search" @click="searchEnterFun">搜索</button>
          <button class="clear" @click="showDropScreen = -1">关闭</button>
        </div>
      </div>
    </div>
    <div class="main-con">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="page_crumb">
        <el-breadcrumb-item>财务分析</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/employee-analysis' }"
          >项目列表</el-breadcrumb-item
        >
        <el-breadcrumb-item v-if="strTableId == 'XZ_emp_FnncSocialInsu'"
          >项目收支表社保</el-breadcrumb-item
        >
      </el-breadcrumb>
      <div class="crumbs" style="width: 99%">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane :label="item.StrTableName" :name="item.StrTableId" v-for="(item, nameindex) in tableNameList" :key="nameindex"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="funcsumTable">
        <!-- :row-class-name="rowClassName" -->
        <div class="count_box">
          <el-button
          type="primary"
          plain
          size="small"
          style="margin-right: 20px"
          @click="statisticsHandle"
          :loading="statisticLoading"
          >最新统计</el-button
        >
        </div>
        <el-table
        class="analysis_table"
          :data="tableData"
          :max-height="tableHeight - 270"
          row-key="id"
          style="width: 99%;"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          @row-click="tableDataClick"
          @expand-change="expandHandle"
          show-summary
          sum-text="总计"
          :summary-method = "getSummaries"
          border
          ref="tableData"
          v-loading="listLoading"
        >
          <template v-for="(item, titleindex) in tableTitle">
            <el-table-column
              :prop="item.StrColumId"
              :label="item.StrColumName"
              fit
              :fixed="item.StrColumName == '总项目名称'?'left':false"
              :key="'title' + titleindex"
              :width="
              item.StrColumName == '总项目名称'
                  ? 300:
                item.StrColumName == '备注'
                  ? 380
                  : item.StrColumName == 'NO'
                  ? 60
                  : item.StrColumName == '姓名'
                  ? 100
                  : 180
              "
              align="center"
            >
             
              <template slot-scope="{ row }">
                <div
                class="d_inline"
                  v-if="
                  item.StrColumName.indexOf('应收') != -1 ||
                    item.StrColumName.indexOf('收入') != -1 ||
                    item.StrColumName.indexOf('金') != -1 ||
                    item.StrColumName.indexOf('支出') != -1 ||
                    item.StrColumName.indexOf('结余') != -1 ||
                    item.StrColumName.indexOf('商保') != -1 ||
                    item.StrColumName.indexOf('险') != -1 ||
                    item.StrColumName.indexOf('个人承担') != -1||
                    item.StrColumName.indexOf('小计') != -1||
                    item.StrColumName.indexOf('收款') != -1||
                    item.StrColumName.indexOf('税') != -1||
                    item.StrColumName.indexOf('差异') != -1
                  "
                >
                  {{
                    !isNull2(row[item.StrColumId])
                      ? Number(row[item.StrColumId]).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })
                      : ""
                  }}
                </div>
                <div
                class="d_inline"
                  v-else-if="
                    item.StrColumName == '插入时间' ||
                    item.StrColumName.indexOf('日期') != -1
                  "
                >
                  {{
                    isNull(row[item.StrColumId])
                      ? ""
                      : row[item.StrColumId].substring(0, 10)
                  }}
                </div>
                <div v-else-if="item.StrColumName == '身份证号码'" class="d_inline">
                  {{ row[item.StrColumId] }}
                </div>
                <div v-else class="d_inline">{{ row[item.StrColumId] }}</div>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div class="block" style="width: 99%">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.currpage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="Number(listQuery.pagecount)"
            layout="total,sizes,prev,pager, next, jumper"
            :total="totalcount"
          ></el-pagination>
        </div>
      </div>
    </div>
     <!-- 统计 -->
      <el-dialog :visible.sync="statisticDialog" width="580px" title="更新统计">
        <div class="flex impdata" style="margin:20px 0">
          <div class="bookkeepingMonth">
            <div class="impTitle">记账月份:</div>
            <el-date-picker v-model="statisticQuery.bookingRealMonth" :picker-options="pickerOptions" type="month" placeholder="选择月" value-format="yyyy-MM"></el-date-picker>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" style="margin-right:15px" @click="statisticDialog = false">取消</el-button>
            <el-button size="mini" slot="reference" type="danger" @click="confirmUp">确认更新</el-button>
        </span>
      </el-dialog>
  </div>
</template>
<script>
import xz from "./../../common";
// import treeToArray from "./../../components/treeTable/eval";
import selMonth from "./../../components/SelectMonth.vue";
import { parseTime } from "./../../utils"; //格式化时间格式
export default {
  components: {
    selMonth
  },
  data() {
    return {
      tableHeight: 0,
      listLoading: false,
      totalcount: null,
      index: '',
      //禁用日期范围
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      tableData: [],
      //列表参数
      listQuery: {
        pagecount: 10,
        currpage: 1,
        strallObjName: "",
        tableid: "XZ_analysis_InvoiceCollection",
        strObjName: "",
        bookingRealMonths: "",
        belongMonths: "",
        strSrvCent: "", //服务中心
      },
      //切换tab
      activeName: "",
      //导出参数
      exportQuery: {
        pagecount: 10000000,
        currpage: 1,
        strallObjName: "", //总项目名称
        tableid: "XZ_analysis_InvoiceCollection",
        strObjName: "", //项目名称
        bookingRealMonths: "",
        belongMonths: "",
        strSrvCent: "", //服务中心
      },
      //下拉服务中心列表
      serviceList: [],
      //导出按钮加载状态
      exportLoading: false,
      //人员角色
      loginRoletype: "",
      //下拉筛选
      showDropScreen: -1,
      //表头数据
      tableTitle: [],
      //是否展开
      expandChange: false,
      strTableId: "",
      //表名数据
      tableNameList:[],
      statisticLoading:false,
      statisticDialog:false,
      //最新统计参数
      statisticQuery:{
        bookingRealMonth:'',
        tableid:''
      },
      //总计
      allCountList:[]
    };
  },
  async created() {
    this.closeAccountType = localStorage.closeAccountType;
    this.loginRoletype = localStorage.loginRoletype;
    this.calHeight();
    await this.getTableList()
    this.getServiceList();
    this.getList();
  },
  methods: {
    //记账日期
    getBookFormSon(data){
      this.listQuery.bookingRealMonths = data
      // console.log('data',data)
    },
    //归属日期
    getBelongFormSon(data){
      this.listQuery.belongMonths = data
      // console.log('belongMonths',data)
    },
    rowClassName({ row, rowIndex }) {
      // console.log("rowClassName", row, rowIndex);
      return row.children ? "haveChildren" : "noHave";
    },
    //更新统计
    statisticsHandle(){
      this.statisticDialog = true
      this.statisticQuery.tableid = this.strTableId
    },
    //确认更新
    confirmUp(){
      if(this.isNull2(this.statisticQuery.bookingRealMonth)){
        this.$message({
            message: "请选择记账日期",
            type: "warning"
          });
          return false
      }else{
        xz.getTaskAnalysisTotalData(this.statisticQuery).then((res) => {
        // console.log("getTableList", res);
        // if (res) {
          this.$message({
            message: "统计数据更新成功！",
            type: "success"
          });
        // } else {
        //   this.$message({
        //     message: "统计数据更新失败！请稍后再试",
        //     type: "error"
        //   });
        // }
        });
        this.statisticDialog =false
          this.getList()
      }
    },
    //分析总计
    getAllCount(){
      xz.getAllAnalysisTotalData(this.listQuery).then(res => {
        // console.log('process', res)
        if(res.status == 'ok'){
          let sums1 = Object.values(res.msg[0])
          for(let i = 0;i<sums1.length;i++){
            sums1[i] = Number(sums1[i]).toLocaleString(undefined, {
              minimumFractionDigits: 2,
            })
          }
          // console.log('ww',sums1)
          // this.allCountList = sums.concat(sums1)
          this.allCountList = sums1
          // console.log('allCountList',this.allCountList)
        }
      })
    },
    //总计
    getSummaries(param){
      const { columns, data } = param;
        let sums = [];
        let sum1 = ['总计']
        let allList = []
        allList = sum1.concat(this.allCountList)
        // console.log('column',data)
        sums = allList
        return sums
    },
    tableDataClick(row, column, event) {
      // console.log("rowClassName", row);
      this.$refs.tableData.toggleRowExpansion(row, !row.expand);
      row.expand = !row.expand;
    },
    // 通过表头关连拿到数据
    toGetColumData(item) {
      // let id =  item.StrColumId;
      // console.log(item);
      return true;
    },
    expandHandle(row, data) {
      // 展开 但是手动给他关掉
      if (!row.children) {
        this.$refs.tableData.toggleRowExpansion(row, false);
      }
    },
    //切换tab
    async handleClick(tab, event) {
      // console.log('tab',tab, event);
      this.listQuery.currpage = 1;
      this.exportQuery.currpage = 1;
      this.listQuery.tableid = tab.name;
      this.exportQuery.tableid = tab.name;
      this.activeName = tab.name
      this.strTableId = tab.name
      await this.getTitleList()
      this.getList();
    },
    //导出
    exportHandle() {
         this.exportQuery.strallObjName = this.listQuery.strallObjName
         this.exportQuery.strObjName = this.listQuery.strObjName
         this.exportQuery.strSrvCent = this.listQuery.strSrvCent
         this.exportQuery.bookingRealMonths = this.listQuery.bookingRealMonths
         this.exportQuery.belongMonths = this.listQuery.belongMonths
         if(this.isNull(this.listQuery.bookingRealMonths)){
             this.$message({
              showClose: true,
              message: "请选择记账日期",
              type: "warning"
            });
            return false
         }else{
            this.exportLoading = true
            xz.getOutAnalysisTotalData(this.exportQuery).then(res => {
                // console.log('process', res)
                if(res.status == 'ok'){
                this.$router.push({
                    path: "/employee-fnnchis",
                    query: {
                    showPage: 1,
                    isActive: 1,
                    custname: res.msg,
                    //qStstus=1时查看最后一条导出记录
                    qStstus: 1
                    }
                })
                }else{
                  this.$message({
                      message: "导出错误，请稍后再试",
                      type: "error"
                  });
                }
                this.exportLoading = false
            })
         }
    },
    //搜索
    searchEnterFun() {
      this.getList();
      this.showDropScreen == -1;
    },
    //筛选下拉
    dropDownScreen() {
      this.showDropScreen = -this.showDropScreen;
    },
    serviceChange() {
      this.getList();
      this.showDropScreen == -1;
    },
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
      // console.log('height',this.tableHeight)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.listQuery.currpage = parseInt(val);
      this.getList();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.listQuery.currpage = 1;
      this.listQuery.pagecount = parseInt(val);
      this.getList();
    },
    //判断是否为空(包含0)
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == 0 ||
        o == "1900/01/01" ||
        o == "1900-01-01T00:00:00" ||
        o == "1900-01-01"
      );
    },
    isNull2(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o === "" ||
        o == "null" ||
        o == []
      );
    },
    async getList() {
       this.listLoading = true
      xz.getAnalysisTotalData(this.listQuery).then((res) => {
        // console.log("getList", res);
        if (res.msg.parent && res.msg.parent.length > 0) {
          let parentList = res.msg.parent
          for (let index = 0; index < parentList.length; index++) {
            this.$set( parentList[index],"id",index+ new Date().getTime() + Math.random() * 10000)+'';
              // parentList[index].hasChildren = true
              // this.recursiveFun(index,parentList[index].children)
              let levelThird = parentList[index].children
              if(!this.isNull2( levelThird)){
                for (let i = 0; i < levelThird.length; i++) {
                  this.$set(levelThird[i],"id",index+ new Date().getTime() + Math.random() * 48000000)+'';
                  if(!this.isNull2( levelThird[i].children)){
                    for (let j = 0; j < levelThird[i].children.length; j++) {
                      levelThird[i].children[j].id = i+ new Date().getTime() + Math.random() * 17000000+'';
                      levelThird[i].children[j].hasChildren = false
                    }
                  }
                }
              }
          }
          this.tableData = parentList
          // console.log('ll',parentList)
          this.totalcount = Number(res.totalcount)
          this.getAllCount()
        } else {
          this.tableData = []
          this.totalcount = 0
        }
         this.listLoading = false
      });
    },
    //设置列表id
    recursiveFun(index,data){
        this.getIDfun(index,data)//需要循环执行的方法
    },
    getIDfun(index,data){
      ++index;
       let dataIndex = data[0]
      this.$set(dataIndex,"id",index+ new Date().getTime() + Math.random() * 48000000)+'';
      // this.$set(dataIndex,"hasChildren",false);
       //判断执行方法的条件（满足什么条件时停止循环执行）
      if(data&&index<data.length){
            this.recursiveFun(index,data) 
      }
    },
    //下拉服务中心列表
    getServiceList() {
      xz.getsrarchinstlist().then((res) => {
        // console.log("getServeList", res);
        let dataList = [];
        for (let index = 0; index < res.length; index++) {
          const service = res[index];
          dataList.push({ StrSrvCent: service.Strinstname });
        }
        // console.log("getServeList", dataList);
        this.serviceList = dataList;
      });
    },
    //表名列表
    getTableList(){
      xz.getAnalysisTable().then((res) => {
        // console.log("getTableList", res);
        if (res && res.msg.data.length > 0) {
          this.tableNameList = res.msg.data
          this.strTableId = res.msg.data[0].StrTableId
          this.activeName = res.msg.data[0].StrTableId
          this.getTitleList()
        } else {
          this.tableNameList = []
        }
      });
    },
    //获取一级表头列表
    getTitleList(){
      xz.getAnalysisColumnInf(this.strTableId).then((res) => {
        // console.log("tableid", res);
        if (res && res.length > 0) {
          this.tableTitle = res
        } else {
          this.tableTitle = []
        }
      });
    },
    //清空
    resetHandle() {
      this.listQuery.pagecount = 10;
      this.listQuery.currpage = 1;
      this.listQuery.strSrvCent = ""; //服务中心
      this.listQuery.strObjName = ''
      this.listQuery.strallObjName = ''
    },
  },
};
</script>


<style scoped lang="scss">
.analysis_table /deep/.el-icon-arrow-right:before {
content: "\e6d9";
}
.analysis_table /deep/.el-table__expand-icon--expanded .el-icon-arrow-right:before{
content: "\e6d8"!important;
}
.analysis_table /deep/.el-table__expand-icon--expanded {
-webkit-transform: rotate(0deg);
transform: rotate(0deg);
}
.analysis_table /deep/.el-table__expand-icon {
border: 1px solid #e7e7e7;
padding:1px;
line-height: 18px!important;
text-align: center !important;
}
.count_box{
  display:flex;
  width: 99%;
  background-color: #fff;
  padding: 10px 0;
  justify-content: flex-end;
}
.page_crumb {
  width: 100%;
  margin: 15px 0;
}
</style>
<style>
.page_analysis .crumbs{
  background-color: #fff;
}
.page_analysis .el-table__cell .cell .el-table__placeholder{
  width: 0;
}
.page_analysis .el-table td:first-child.el-table__cell div{
  text-align: left;
}
.el-table__row.noHave td:first-child .el-icon-arrow-right {
  visibility: hidden;
}
.d_inline{
  display:inline-block;
}
.page_analysis .formScreenInput .el-input__inner {
  width: 210px;
}
.page_analysis .el-tabs__header {
  margin: 0;
}
.page_analysis .screenInput .el-input {
  width: 180px;
}
.page_analysis .screenInput .el-date-editor.el-input {
  width: 130px;
}
.page_analysis .el-date-editor .el-input__inner {
  height: 32px;
  line-height: 32px;
}
.page_analysis .el-date-editor .el-input__icon {
  line-height: 33px;
}
.page_analysis .el-select .el-input__inner {
  height: 32px;
  line-height: 32px;
}
.page_analysis .el-select .el-input__icon {
  line-height: 32px;
}
</style>